import Vue from "vue";
import TreeSelect from "@riophae/vue-treeselect";

Vue.component("tree-select", TreeSelect);
